import React from "react";
import { makeStyles } from "tss-react/mui";
import { Box, Drawer } from "@mui/material";
import CustomDrawerHeader from "./CustomDrawerHeader";

const useStyles = makeStyles()((theme, { paperWidth, fitContent } = {}) => {
  return {
    drawerPaper: {
      margin: "10px",
      width: `min(${paperWidth || "700px"}, calc(100vw - 20px))`,
      height: fitContent ? "auto" : "calc(100% - 20px)",
      maxHeight: "calc(100% - 20px)",
      bottom: fitContent ? "auto" : undefined,
      display: "flex",
      flexDirection: "column",
      borderRadius: "30px",
      zIndex: theme.zIndex.drawer + 2,
      position: "absolute",
      [theme.breakpoints.down("sm")]: {
        width: "calc(100% - 20px)",
        borderRadius: "16px",
      },
    },
  };
});

export default function CustomDrawer({
  isDrawerOpen,
  handleClose,
  anchor,
  title,
  subtitle,
  otherText,
  fontSize,
  children,
  isOnlyIconClose = false,
  paperWidth,
  fitContent,
}) {
  const { classes } = useStyles({ paperWidth, fitContent });
  return (
    <Drawer
      open={isDrawerOpen}
      onClose={!isOnlyIconClose && handleClose}
      anchor={anchor || "right"}
      variant="temporary"
      classes={{ paper: classes?.drawerPaper }}
      transitionDuration={{ enter: 500, exit: 500 }}
    >
      {title ? (
        <Box sx={{ flexShrink: 0 }}>
          <CustomDrawerHeader
            handleClose={handleClose}
            title={title}
            subtitle={subtitle}
            otherText={otherText}
            fontSize={fontSize}
          />
        </Box>
      ) : null}
      <Box sx={{ overflow: "auto", flex: 1, minHeight: 0 }}>
        {children}
      </Box>
    </Drawer>
  );
}
